export default __webpack_public_path__ + "static/media/nurani.d9660e04.png";